import {GTM} from "./gtm";
import {DRAWER} from "./drawer";
import {U, BROWSE, __, TOOLTIP, CATALOG} from "./global";
import {FILTER} from "./filter";
import "./../js/fancybox/source/jquery.fancybox";
import {DELIVERYMAP} from "./deliverymap";

export const GOODS = {
    cls: 0,
    accs_filter_loaded: false,
    exists_goods: [],
    exists_urls: [],
    goods_id: 0,
    conf_expand: 0,
    locale: 0,
    write_history: true,
    mobile_go_to: 0,
    current_price: 0,
    in_loading: false,
    similar: '',
    previousState: window.location.href,
    recaptcha_id: false,
    video_added: false,
    player: false,
    slick_move: false,
    was_url: '',
    current__tab: 'main',
    current__url: '',
    postData: async function (data = {}, url = '/aj') {
        data.locale = G.locale_id;
        data.mobile = (U.isMobile()?1:0);

        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: new URLSearchParams(data)
        });
        return response.json(); // parses JSON response into native JavaScript objects
    },
    update_delivery: function(id) {
        $.post(
            '/aj',
            {
                action: 'goods',
                to: 'delivery',
                locale: G.locale_id,
                id: id,
            },
            function (data) {
                $(".product__sc-delivery").replaceWith(data.html);
            },
            'json'
        );
    },
    current_tab: function() {
        return this.current__tab;
    },
    current_url: function(){
        return window.location.pathname;
    },
    push_history: function(id, url, tab) {
        history.pushState({
            id: id,
            url: url,
            tab: tab,
        }, null, url);
    },
    open_video_popup: function(embed) {
        U.loadscript('https://www.youtube.com/iframe_api', () => {
            $("body .iframe-popup").remove();
            $("body").append('<div class="iframe-popup"><div id="iframe_popup"></div></div>');

            embed = embed.split('/');
            embed = embed[embed.length - 1];
            embed = embed.split('?');
            embed = embed[embed.length - 1];
            GOODS.player = new YT.Player('iframe_popup', {
                height: 'auto',
                width: '100%',
                videoId: embed,
                events: {
                    'onReady': GOODS.played_ready,
                    'onStateChange': GOODS.player_change
                }
            });
        });
    },
    played_ready: function(event){
        GOODS.player.playVideo();
    },
    player_change: function(event){

    },
    player_close: function(event){
        $(".iframe-popup").animate({
            opacity: 0
        }, 300, function() {
            GOODS.player.stopVideo();
            GOODS.player = false;
            $(".iframe-popup").remove();
        });
    },

    load_goods: function(id, tab){
        GOODS.locale = G.locale_id;
        $(".main-contain").addClass('semifade');

        id = typeof id === "object" ? id.id : id;

        GOODS.in_loading = true;

        if (U.isset(GOODS.exists_goods[id])) {
            setTimeout(() => {
                GOODS.replace_data(id, tab);
                GOODS.goods_id = id;
                G.product.id = id;
            }, 0)
        } else {
            $.post(
                '/aj',
                {
                    action: 'goods',
                    to: 'index',
                    confexpand: GOODS.conf_expand,
                    locale: GOODS.locale,
                    id: encodeURIComponent(id)
                },
                (data) => {
                    GOODS.exists_goods[data.id] = data;
                    GOODS.exists_urls[data.url] = data.id;
                    GOODS.replace_data(data.id, tab);
                    GOODS.goods_id = data.id;
                    G.product.id = data.id;
                    CATALOG.updateSeo(data.seo.title, data.seo.text);
                    GOODS.updateBlog(data.global.blog);
                },
            'json');
        }
    },

    updateBlog: function(block) {
        $(".product__descright").find('.js-product__block-reviews').remove();

        if (block!='') {
            $(".product__descright").append(block);
        }
    },

    replace_data: function(id, tabname = 'main') {
        return new Promise((resolve, reject) => {
            let data = this.exists_goods[id];
            this.video_added = false;

            if (data.success) {
                if (this.similar=='')
                    this.similar = $(".product__similarcontainer").html();

                $(".main-contain").removeClass('semifade')
                $(".product").replaceWith(data.main);
                $(".product__similarcontainer").html(this.similar);
                document.title = data.global.title;
                this.init_product();

                if (this.write_history) {
                    this.push_history(id, data.url + '#' + GOODS.current_tab(), GOODS.current_tab());
                    GTM.event('pageview', data.url);
                    this.was_url = data.url;
                }

                // if (tabname)
                //$(`.js-go-tabproduct[data-tab=${tabname}]`).trigger('click');

                this.write_history = true;
            }

            resolve();
        }).finally(() => {
            this.in_loading = false;
            setTimeout(() => $(".main-contain").removeClass('semifade'), 200);

        });
    },

    sliderCounter: function(index) {
        let length = $(".product__image .slick-track .slick-slide:not(.slick-cloned)").length;
        if (length)
            $(".product__imagescounter").html(index + '/' + length);
    },

    put_video_on_tab: function() {
        // parse landing
        if (!this.video_added) {
            this.video_added = true;

            $(".photos-full iframe").remove();
            if ($(".landing iframe").length > 0) {
                let last_index = $('a[data-fancybox-group=button]:last-child').data('index') + 1;
                $.each($(".landing iframe"), function(i, item){
                    item = $(item);
                    let src = item.data('src') ?? item.attr('src');
                    let index = $(".product__imagelist .product__imageitem").length > 3 ? 3 : ($(".product__imagelist .product__imageitem").length - 1);

                    console.log($(`.product__imagelist .product__imageitem:eq(${index})`));
                    $(".photos-full").append(`<iframe loading="lazy" style="min-height: 400px !important;" data-fancybox-group="button" src="${src}" data-index="${last_index}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`);
                    $(`<a class="product__imageitem slide video" href="${src}" data-index="${last_index}" data-big="${src}">
                        <iframe loading="lazy" class="mobileVisible" style="min-height: 400px !important;" src="${src}" data-index="${last_index}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </a>`).insertAfter($(`.product__imagelist .product__imageitem:eq(${index})`));
                    last_index++;
                });
            }
        }
    },

    mainProductSlider: function() {

        if ($(".product__imagelist").length > 0) {
            if (U.isMobile()) {

                $(".more-description").click(function(e){
                    e.preventDefault();

                    let btn = $(this);
                    btn.parent().find('article, .landing').addClass('full');
                    btn.remove();
                });

                if ($(".product__imagelist:not(.slick-initialized)").length > 0)
                    $(".product__imagelist").slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        rows: 0
                    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        GOODS.sliderCounter(nextSlide + 1);
                    });

                GOODS.sliderCounter(1);

            } else {
                $(".product__imagelist .slide:not(.active) img").addClass('lazyload');

                $(".product__imagelist a").click(function(e){
                    e.preventDefault();

                    let btn = $(this);
                    $(".product__imagelist a").removeClass('product__imageitem-active');
                    btn.addClass('product__imageitem-active');

                    if (btn.hasClass('video')) {
                        $(".product__imagemain").html('<iframe loading="lazy" width="100%" height="100%" src="' + btn.attr('href') + '?autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen frameborder="0" border="0" ></iframe>');
                    } else {
                        $(".product__imagemain").html(`
                            <a href="javascript: void(null);" class="product__imagemainarr hiddenMobile product__imagemainarr-left js-product__imagemainarr-left"></a>
                            <a href="javascript: void(null);" class="product__imagemainarr hiddenMobile product__imagemainarr-right js-product__imagemainarr-right"></a>
                            <a href="${btn.attr('href')}" data-index="${btn.data('index')}" class="product__imagemaina active js-product__imagemain">
                                <picture>
                                    <img loading="lazy" src="${btn.attr('href')}" />
                                </picture>
                            </a>`);
                    }
                });

                jQuery("body").on('click', '.js-product__imagemain', function(e) {
                    e.preventDefault();

                    let btn = $(this);

                    console.log(btn);

                    setTimeout(() => {
                        $.fancybox.open($("[data-fancybox-group=button]"), {
                            beforeShow: function () {
                                let element = $(this.element);
                                if (element.prop("tagName")=='IFRAME')
                                    element.attr('src', element.data('src')).css({
                                        'width': 800,
                                        'height': 500,
                                        'max-width': '100%',
                                        'max-height': '100%',
                                    });

                                this.title += '<a href="javascript: void(null);" class="fancybox-button fancybox-button--original"></a>';
                            },
                            openEffect  : 'none',
                            closeEffect : 'none',
                            prevEffect : 'none',
                            nextEffect : 'none',
                            padding : 70,
                            helpers : {
                                title : {
                                    type : 'inside'
                                }
                            },
                            index: btn.data('index')
                        });
                    }, 0);
                });

            }
        }
    },

    tabChange: function() {
        return;
    },

    changed_string: function(count) {
        let suffix = '';
        let prefix = __('Змінено');

        if (count == 1) {
            suffix = __('характеристика');
            prefix = __('Змінена');
        }

        if (count >= 2 && count <= 4)
            suffix = __('характеристики');

        if (count > 4)
            suffix = __('характеристик');

        return prefix + ' <num>' + count + '</num> ' + suffix;
    },

    sliderBundle: function() {
        if ($(".bundle__list:not(.slick-initialized) .bundle").length > 0)
            $('.bundle__list').slick({
                arrows:true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: true
            }).on('afterChange', function(event, slick, currentSlide, nextSlide){
                U.send_impressions();
            });
    },

    sliderAccs: function() {
        if ($(".product__left .js-go-tabproduct[data-tab=main]").hasClass('active') && $(".vertical-accessories .accessories-slider .viewedlist").length)
            $('.vertical-accessories .accessories-slider').slick({
                arrows:true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: true
            }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                U.slickBeautify(slick);
            });
    },

    recalculateFewCountPromo: function() {
        if ($(".bundle.few-count").length > 0) {
            $.each($(".bundle.few-count"), function (i, bundle) {
                bundle = $(bundle);

                if (bundle.find('.conditions >.regular').length) {
                    bundle.find('.conditions >.regular').sort(function (a, b) {
                        a = $(a);
                        b = $(b);

                        return a.find('.price').data('price') == b.find('.price').data('price') ? 0 : (a.find('.price').data('price') > b.find('.price').data('price') ? -1 : 1);
                    }).prependTo(bundle.find('.conditions'));

                    // recalculate price
                    let discount = bundle.data('discount').split(',');
                    let summ = 0;
                    let summ_old = 0;

                    $.each(bundle.find('.conditions >.regular'), function (key, item) {
                        item = $(item);
                        let price = item.find('.price').data('price');
                        let price_old = '';
                        let percent = 0;

                        summ_old += parseInt(price);

                        if (typeof discount[key] === "string" && !(discount[key] == "")) {
                            try {
                                price_old = price;
                                // recalculation
                                if (discount[key].substr(-1, 1) == '%') {
                                    let discount_percent = 100 - parseInt(discount[key].slice(0, -1));
                                    percent = 100 - discount_percent;
                                    price = Math.round(parseInt(price) * (discount_percent / 100));
                                } else {
                                    price = parseInt(discount[key]);
                                    percent = 100 - parseInt((price / price_old) * 100);
                                }
                            } catch (e) {
                            }
                        }

                        if (price_old)
                            item.find('.price').addClass('promo');
                        else
                            item.find('.price').removeClass('promo');

                        summ += parseInt(price);

                        // discount sticker
                        item.find('.image span').remove();

                        if (percent)
                            item.find('.image').append('<span class="discount">-' + percent + '%</span>');

                        item.find('.price').html((price_old ? '<del>' + price_old + '</del>' : '') + price + '&nbsp;грн');
                    });

                    // recalculate sum
                    if (summ < summ_old)
                        bundle.find('.total .price').addClass('promo').html('<del>' + summ_old + '</del>' + summ + '&nbsp;грн');
                    else
                        bundle.find('.total .price').removeClass('promo').html(summ + '&nbsp;грн');

                }
            });
        } else if ($(".bundle").length) {
            $.each($(".bundle"), function (i, bundle) {
                bundle = $(bundle);

                if (bundle.find('.bundle__condition-regular').length > 0) {
                    // recalculate price
                    let summ = 0;
                    let summ_old = 0;

                    $.each(bundle.find('.bundle__condition-regular'), function (key, item) {
                        item = $(item);

                        if (item.find('.bundle__price').length > 0) {
                            let smo = parseInt(item.find('.bundle__price').data('summ_old'));

                            if (typeof smo === "number" && !isNaN(smo)) {
                                summ_old += smo;
                            }

                            let sm = parseInt(item.find('.bundle__price').data('price'));

                            if (typeof sm === "number" && !isNaN(sm)) {
                                summ += sm;
                            }
                        }
                    });

                    // recalculate sum
                    if (summ < summ_old)
                        bundle.find('.bundle__totalprice').addClass('promo').html('<del>' + summ_old + '</del>' + summ + '&nbsp;грн');
                    else
                        bundle.find('.bundle__totalprice').removeClass('promo').html(summ + '&nbsp;грн');

                }
            });
        }
    },

    load_small_comment_form: function() {
        return;
    },

    init_product: function() {

        // this.put_video_on_tab();

        this.mainProductSlider();

        this.sliderBundle();

        this.recalculateFewCountPromo();

        this.slick_block_accs();
    },

    id: function() {
        return this.goods_id;
    },

    slick_block_accs: function() {
        if ($(".js-product__blockaccs").hasClass('slick-initialized'))
            $('.js-product__blockaccs').slick('unslick');

        $(".js-product__blockaccs").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            dots: true,
            prevArrow: `<button class="product__blockaccsa product__blockaccsa-prev hiddenMobile" type="button"></button>`,
            nextArrow: `<button class="product__blockaccsa product__blockaccsa-next hiddenMobile" type="button"></button>`,
            rows: 0
        });
    }
};

export function init_GOODS_events() {
    console.info('goods loaded');
    jQuery(document).ready(function () {

        if (document.location.hash=='#openmap') {
            DELIVERYMAP.productCityChoose(gtm_product_details.sku);
        }

        jQuery("body").on("click touchend touch touchstart touchmove", ".video >.iframe_overflow", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (e.type == 'touchmove') {
                GOODS.slick_move = true;
            } else {
                if (e.type == 'click' || e.type == 'touchend') {
                    if (!GOODS.slick_move) {
                        let btn = $(this);
                        GOODS.open_video_popup(btn.parent().find('iframe').attr('src'));
                    }
                    GOODS.slick_move = false;
                }
            }

        });

        jQuery("body").on("click", ".iframe-popup", function (e) {
            let target = $(e.target);
            if (target.hasClass('iframe-popup')) {
                e.preventDefault();
                e.stopPropagation();
                $(".iframe-popup").remove();
            }
        });

        jQuery("body").on("click", ".workdrawer .conf-list li", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (!U.isMobile()) {
                GOODS.load_goods(btn.data('id'), GOODS.current_tab());
                DRAWER.destroy();
                return;
            } else {
                $(".workdrawer .conf-list li").removeClass('data-out').removeClass('data-in');
                let changed_counter = {}

                if (btn.data('in').length) {
                    $.each(btn.data('in').split(','), function (i, ind) {
                        let ids = ind.split('_');
                        changed_counter[ids[0]] = 1;

                        if (ids.length > 1)
                            $(".workdrawer .conf-list >div:eq(" + ids[0] + ") li:eq(" + ids[1] + ")").addClass('data-in');
                    });
                }
                if (btn.data('out').length) {
                    $.each(btn.data('out').split(','), function (i, ind) {
                        let ids = ind.split('_');
                        changed_counter[ids[0]] = 1;

                        if (ids.length > 1)
                            $(".workdrawer .conf-list >div:eq(" + ids[0] + ") li:eq(" + ids[1] + ")").addClass('data-out');
                    });
                }

                changed_counter = Object.keys(changed_counter).length;

                GOODS.mobile_go_to = btn.data('id');

                $(".workdrawer .amount .total").html(btn.data('price') == GOODS.current_price ? btn.data('price') : '<del>' + GOODS.current_price + '</del>' + btn.data('price'));

                if (changed_counter)
                    $(".workdrawer .changed").html(GOODS.changed_string(changed_counter));
                else
                    $(".workdrawer .changed").empty();
            }
        });

        jQuery("body").on("click", ".js-conf__dogoods", function (e) {
            e.preventDefault();
            if (GOODS.mobile_go_to)
                GOODS.load_goods(GOODS.mobile_go_to, 'do-goods');

            DRAWER.destroy();
        });

        jQuery("body").on("click", ".changeGoods", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);

            if (btn.prop("tagName") == 'LI')
                btn = btn.find('a');

            if (btn.hasClass('activeBtn'))
                return;

            if (btn.data('id')) {
                GOODS.load_goods(btn.data('id'), GOODS.current_tab());
            }
        });

        jQuery("body").on("mouseover", ".product__conf-optionslist .conf__a, .workdrawer-configurator .conf-list li", function (e) {
            e.preventDefault();
            let btn = $(this);
            let dout = btn.data('out').split(',');
            let din = btn.data('in').split(',');
            let container = btn.parents('.conf-list').length ? '.conf-list' : '.product__conf';
            let changed_counter = {};

            if (dout.length)
                $.each(dout, function (i, item) {
                    item = String(item);
                    if (item.length) {
                        $(container + " ." + item).addClass('data-out');
                        item = item.split('_');
                        changed_counter[item[0]] = 1;
                    }

                });

            if (din.length)
                $.each(din, function (i, item) {
                    item = String(item);
                    if (item.length) {
                        $(container + " ." + item).addClass('data-in');
                        item = item.split('_');
                        changed_counter[item[0]] = 1;
                    }

                });

            $(".conf__changed").html(Object.keys(changed_counter).length > 0 ? GOODS.changed_string(Object.keys(changed_counter).length) : '');
            $(".conf__total").html(btn.data('price') == GOODS.current_price ? btn.data('price') : '<del>' + GOODS.current_price + '</del>' + btn.data('price'));
        });

        jQuery("body").on("mouseout", ".product__conf-optionslist .conf__a, .workdrawer-configurator .conf-list li", function (e) {
            $(".conf-list .data-in, .conf-list .data-out, .product__conf .data-in, .product__conf .data-out").removeClass('data-in').removeClass('data-out');
            $(".workdrawer .changed").empty();
            $(".workdrawer .amount .total").html(GOODS.current_price ? GOODS.current_price : __('Немає в наявності'));
        });

        jQuery("body").on("click touchend", ".js-go-tabproduct", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let newtab = btn.data('tab');
            let suffix = '?tab=';
            let active_tab = $(".js-go-tabproduct.active").data('tab');

            if (!(typeof e.originalEvent === "undefined")) {
                GOODS.current__tab = newtab;
                GOODS.push_history(GOODS.id(), GOODS.current_url() + '#' + GOODS.current_tab(), GOODS.current_tab());
                // $(".js-go-tabproduct[data-tab=main]").trigger('click');
            }

            $(".tabs .active, .ctabs .active").removeClass('active ctabs__a-active');
            $(".tabs [data-tab=" + newtab + "], .ctabs [data-tab=" + newtab + "]").addClass('active ctabs__a-active');

            $(".product__main, .wrapper-product-bottom, .wrapper-tabs, .product__tab").addClass('hidden');

            if (G.portal_id == 7) {
                if (newtab == 'main') {
                    $(".product__main, .wrapper-product-bottom").removeClass('hidden');
                    $(".product__sticky").removeClass('product__sticky-border');
                } else {
                    $(".product__sticky").addClass('product__sticky-border');
                    $(".wrapper-tabs").removeClass('hidden');
                    $(".product__tab[data-tab=" + newtab + "]").removeClass('hidden');
                }
            } else {
                if (newtab == 'main') {
                    $(".product__main, .wrapper-product-bottom").removeClass('hidden');
                    $(".product__sticky").removeClass('product__sticky-border');
                } else {
                    $(".product__sticky").addClass('product__sticky-border');
                    $(".wrapper-tabs").removeClass('hidden');
                    $(".product__tab[data-tab=" + newtab + "]").removeClass('hidden');
                }
            }

            // INP
            setTimeout(() => {
                switch (newtab) {

                    case 'main':
                        // GOODS.init_product();
                        break;

                    case 'details':
                        suffix += 'details';

                        if (!$(".product__details").hasClass('product__details-filled')) {
                            $(".optionsfull").clone().appendTo($(".product__details"));
                            $(".product__details").addClass('product__details-filled');
                        }
                        break;

                    case 'photos':
                        suffix += 'photos';
                        break;

                    case 'comments':
                        suffix += 'comments';

                        if ($(".product__tab-comments .review").length == 0) {
                            $(".product__tab-comments > .js-write-review").trigger('click');
                        }
                        break;

                    case 'questions':
                        suffix += 'questions';
                        break;

                    case 'accs':
                        suffix += 'accs';

                        if (1 || !GOODS.accs_filter_loaded) {
                            $(".product__accscontent").addClass('product__accscontent-loading');

                            FILTER.setExtendParams({
                                product_id: GOODS.id()
                            });

                            FILTER.extend_options({
                                filter: {
                                    url: '/accs/',
                                    is_catalog: 1,
                                    catalog_id: 6,
                                    currentpage: 1,
                                    originpage: 1,
                                    action: 'accs',
                                    change_url: false,
                                    force_update: 1,
                                    title_replace: false,
                                    more_opened: false,
                                    filter_replace: true,
                                    catalog_default_sort_field: 'top',
                                    catalog_default_sort_direction: 'asc',
                                }
                            });

                            GOODS.postData(
                                {
                                    action: 'goods',
                                    to: 'accstab',
                                    id: GOODS.id()
                                }
                            ).then((data) => {
                                $(".product__accscontent").html(data.html);
                                FILTER.load(1).then(() => {
                                    GOODS.accs_filter_loaded = true;

                                    if ($(".filter__item[data-name=context]").length < 2) {
                                        if (FILTER.is_accs()) {
                                            if ($(".filter__item[data-name=context]").length==1) {
                                                $(".filter__item[data-name=context]").trigger('click');
                                            }
                                        } else {
                                            $(".filter").addClass('hidden');
                                            $(".catalog__goods").addClass('catalog__goods-full');
                                        }
                                    }

                                    $(".product__accscontent").removeClass('product__accscontent-loading');
                                });
                            });
                        }

                        break;

                    default:
                        suffix = '';
                        break;
                }
            }, 0);

            if (newtab != 'main') {
                $(".wrapper-accsblock").empty().removeClass('hidden');
                if ($(".product__block-accs").length > 0) {
                    let el = $(".product__block-accs").clone();
                    el.appendTo('.wrapper-accsblock');
                }
            } else {
                $(".wrapper-accsblock").addClass('hidden');
            }

            if (newtab == 'accs') {
                $(".product__aside").addClass('mobileVisible');
            } else {
                $(".product__aside").removeClass('mobileVisible');
            }

            $("html, body").stop().animate({scrollTop: U.isMobile() ? 0 : ($("section.product").offset().top - (U.isMobile() ? 45 : 40))}, '100', 'swing');

            return;
        });

        if ($(".product").length > 0) {
            jQuery("body").on("click", ".conf__bundle", function (e) {
                e.preventDefault();
                let btn = $(this);

                GOODS.current_price = btn.data('price');

                DRAWER.init('workdrawer-full workdrawer-configurator', {
                    action: 'goods',
                    to: 'configurator',
                    id: btn.data('id')
                });
            });

            GOODS.init_product();
        }

        jQuery("body").on("click", ".bundle .js-change-gift", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            $('.for-change-bundle').removeClass('for-change-bundle');
            btn.parent().parent().addClass('for-change-bundle');

            DRAWER.init('workdrawer-full workdrawer-bundle-gift', {
                action: 'goods',
                to: 'bundle',
                promotion_id: btn.data('promotion_id'),
                part_number: btn.parents('.bundle').hasClass('few-count') ? 0 : btn.data('part_number'),
                sku: btn.data('sku'),
                product: btn.data('product_sku')
            });
        });

        jQuery("body").on("click", ".workdrawer-bundle-gift .cart__gift", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            btn.parent().find('.cart__gift').removeClass('cart__gift-selected');
            btn.addClass('cart__gift-selected');
            let promo_class = btn.find('.cart__giftprice del').length ? 'bundle__price-promo' : '';

            $('.for-change-bundle').html(`<a href="${btn.find('.cart__giftimage').attr('href')}" class="bundle__image">${btn.find('.cart__giftimage').html()}</a>
                <div class="bundle__content">
                <a href="${btn.find('.cart__giftimage').attr('href')}" class="bundle__title">${btn.find('.cart__gifttitle').html()}</a>
                <span class="bundle__price bundle__price-inline ${promo_class}" data-sku="${btn.data('sku')}" data-price="${btn.find('.cart__giftprice').data('price')}" data-price_old="${btn.find('.cart__giftprice').data('price_old')}">${btn.find('.cart__giftprice').html()}</span>
                <a href="javascript: void(null)" class="change-gift js-change-gift" data-promotion_id="${btn.data('promotion_id')}" data-product_sku="${btn.data('product_sku')}" data-sku="${btn.data('sku')}" data-part_number="${btn.data('part_number')}">Замінити</a>
                </div>`);

            GOODS.recalculateFewCountPromo();
            DRAWER.destroy();
        });

        if (U.isMobile()) {
            jQuery("body").on('click', '.product__imagelist .product__imageitem', function (e) {
                e.preventDefault();
                setTimeout(() => {
                    DRAWER.init('workdrawer-product-gallery', {
                        action: 'goods',
                        to: 'gallery',
                        id: GOODS.id()
                    }, function () {

                        $('.product__gallerybiginner').slick({
                            arrows: false,
                            dots: false,
                            asNavFor: '.product__gallerynavinner',
                        });

                        $('.product__gallerynavinner').slick({
                            slidesToShow: 3,
                            dots: false,
                            centerMode: true,
                            asNavFor: '.product__gallerybiginner',
                            prevArrow: '<button class="product__galleryarrow product__galleryarrow-prev" type="button"></button>',
                            nextArrow: '<button class="product__galleryarrow product__galleryarrow-next" type="button"></button>'
                        });

                    });
                }, 0);
            });

            jQuery("body").on('click', '.product__outletphoto', function (e) {
                e.preventDefault();
                const container = $(this).parent();
                setTimeout(() => {
                    DRAWER.init('workdrawer-product-gallery', {
                        action: 'goods',
                        to: 'galleryoutlet',
                        sku: container.data('sku')
                    }, function () {

                        $('.product__gallerybiginner').slick({
                            arrows: false,
                            dots: false,
                            asNavFor: '.product__gallerynavinner',
                        });

                        $('.product__gallerynavinner').slick({
                            slidesToShow: 3,
                            dots: false,
                            centerMode: true,
                            asNavFor: '.product__gallerybiginner',
                            prevArrow: '<button class="product__galleryarrow product__galleryarrow-prev" type="button"></button>',
                            nextArrow: '<button class="product__galleryarrow product__galleryarrow-next" type="button"></button>'
                        });

                    });
                }, 0);
            });

        } else {
            jQuery("body").on("click", ".photos-full a", function (e) {
                e.preventDefault();
                let btn = $(this);

                $.fancybox.open($("a[data-fancybox-group=button]"), {
                    openEffect: 'none',
                    closeEffect: 'none',
                    prevEffect: 'none',
                    nextEffect: 'none',
                    padding: 70,
                    helpers: {
                        title: {
                            type: 'inside'
                        },
                        buttons: {}
                    },
                    index: btn.data('index')
                })
            });

            jQuery("body").on("click", ".product__outletphoto", function (e) {
                e.preventDefault();
                let btn = $(this);

                $.fancybox.open(btn.parent().find('>a'), {
                    openEffect: 'none',
                    closeEffect: 'none',
                    prevEffect: 'none',
                    nextEffect: 'none',
                    padding: 70,
                    helpers: {
                        title: {
                            type: 'inside'
                        },
                        buttons: {}
                    },
                    index: btn.index()
                })
            });
        }

        if (!(typeof viewproduct === "undefined")) {
            if (!(typeof viewkey === "undefined" || typeof viewproduct === "undefined"))
                BROWSE.set(viewkey, viewproduct);

            GOODS.goods_id = viewproduct.id;
            G.product.id = viewproduct.id;
            GOODS.was_url = GOODS.current_url();

            window.addEventListener('popstate', function (event) {
                if (event.state) {
                    GOODS.write_history = false;
                    GOODS.load_goods(event.state, event.state.tab);
                }
            });

            history.replaceState({
                id: GOODS.goods_id,
                url: GOODS.current_url() + '#' + GOODS.current_tab(),
                tab: GOODS.current_tab()
            }, document.title, `${GOODS.current_url()}${window.location.search}`);
        }

        jQuery("body").on('click', '.fancybox-button--original', function (e) {
            e.preventDefault();
            if (U.isMobile()) {
                window.open($(".product__gallerybiginner .slick-current.slick-active .product__imageitem").data('big'));
            } else {
                window.open($(".fancybox-inner img.fancybox-image").attr('src'));
            }
        });

        // let cls_send = false;
        // try {
        //     const po = new PerformanceObserver((list) => {
        //         for (const entry of list.getEntries()) {
        //             let _value = Math.round(entry.value * 1000);
        //
        //             GOODS.cls += Math.round(entry.value * 1000);
        //
        //             // console.log('cls', entry.value);
        //
        //             if (!cls_send && _value >= 1) {
        //                 /*
        //                 dataLayer.push(
        //                     {
        //                         'event': 'customTiming',
        //                         'timingVar': 'a-cls', //entry.entryType
        //                         'timingCategory': 'PageSpeed',
        //                         'timingValue': _value,
        //                     }
        //                 );
        //                  */
        //                 cls_send = true;
        //             }
        //
        //             if (_value >= 5)
        //                 dataLayer.push(
        //                     {
        //                         'event': 'customTiming',
        //                         'timingVar': 'a-cls-big',
        //                         'timingCategory': 'PageSpeed',
        //                         'timingValue': _value,
        //                     }
        //                 );
        //         }
        //     });
        //
        //     po.observe({type: 'layout-shift', buffered: true});
        // } catch (e) {
        //     // Do nothing if the browser doesn't support this API.
        // }

        $(window).bind('beforeunload', function () {
            // do something, preferably ajax request etc
            dataLayer.push(
                {
                    'event': 'customTiming',
                    'timingVar': 'cls', //entry.entryType
                    'timingCategory': 'PageSpeed',
                    'timingValue': GOODS.cls,
                }
            );
        });

        // купить в кредит
        jQuery("body").on("click", ".buy-in-credit-btn, .buy-in-credit-trigger, .js-buy-in-credit-trigger", function (e) {
            e.preventDefault();

            let btn = $(this);

            DRAWER.init('workdrawer-buy-in-credit workdrawer-full', {
                action: 'goods',
                to: 'buyincredit',
                group_id: btn.data('group'),
                sku: btn.data('sku')
            }, function () {
                if ($(".bc__creditlist >div.active").length > 0) {
                    $(".bc__creditlist >div.active").trigger('click');
                }
            });
        });

        // услуги
        jQuery("body").on("change", ".product__servicetitle-radio [type=checkbox]", function (e) {
            let input = $(this);

            if (input.prop('checked'))
                $("[type=checkbox][name=" + input.attr('name') + "]:checked").not(input).prop('checked', false);
        });

        // акси
        jQuery("body").on("click", ".js-product__accschangetab", function (e) {
            e.preventDefault();
            let btn = $(this);
            let was = btn.hasClass('active');
            $(".js-product__accschangetab").removeClass('active');

            if (!was)
                btn.addClass('active');

            $(".product__accstab").addClass('product__accstab-loading');

            GOODS.postData(
                {
                    action: 'goods',
                    to: 'accstab',
                    id: GOODS.id(),
                    context_id: was ? 0 : btn.data('category')
                }
            ).then((data) => {
                $(".product__accscontent").removeClass('product__accscontent-loading').addClass('product__accscontent-filled').find('.product__accstab').html(data.html);
            }).finally(() => {
                $(".product__accstab").removeClass('product__accstab-loading');
            });
        });
        
        // акси
        jQuery( "body" ).on( "click", ".js-product__blockaccschangetab", function(e){
            e.preventDefault();
            let btn = $(this);
            let was = btn.hasClass('active');
            $(".js-product__blockaccschangetab").removeClass('accs__tab-active');
            btn.addClass('accs__tab-active');

            $(".product__blockaccs").empty().addClass('product__blockaccs-loader');

            GOODS.postData(
                {
                    action: 'goods',
                    to: 'blockaccstab',
                    id: GOODS.id(),
                    context_id: btn.data('category')
                }
            ).then((data) => {
                $(".product__blockaccs").replaceWith(`<div class="product__blockaccs mobile-padding"></div>`);
                $(".product__blockaccs").html(data.html);
                GOODS.slick_block_accs();

                if (data.link!='') {
                    $(".js-product__blockaccs-go").attr('href', data.link).removeClass('js-go-tabproduct');
                } else {
                    $(".js-product__blockaccs-go").addClass('js-go-tabproduct');
                }

            }).finally(() => {

            });
        });

        if (typeof gtm_product_details === "object") {
            GTM.event('product_details', gtm_product_details);
        }

        document.addEventListener('scroll', function (e) {
            if (U.isInView($(".add-comment-form-small")))
                GOODS.load_small_comment_form();

            $('iframe.lazyload').not('.loaded').each(function () {
                if (U.IsInViewport($(this))) {
                    $(this).attr('src', $(this).data('src')).addClass('loaded');
                }
            });
        });

        if (document.location.hash == '#comments') {
            $(".js-go-tabproduct[data-tab=comments]").trigger('click');
        }

        jQuery( "body" ).on( "click", ".js-product__blockaccsscrollbtn", function(e){
            e.preventDefault();
            let btn = $(this);
            let direction = btn.hasClass('viewedlist__prev') ? 'left' : 'right';
            let block = $(".product__blockaccs");

            let to = direction=='left' ? block.scrollLeft() - 824 : block.scrollLeft() + 824;
            let set_prev_disabled = false;

            if (to < 0) {
                to = 0;
                set_prev_disabled = true;
            }

            if (set_prev_disabled) {
                $(".viewedlist__prev.js-product__blockaccsscrollbtn").addClass('slick-disabled');
            } else {
                $(".viewedlist__prev.js-product__blockaccsscrollbtn").removeClass('slick-disabled');
            }

            // next
            let set_next_disabled = false;

            if (direction=='right') {
                let total_width = 0;

                $(".product__blockaccs .hb__loop").map((i, item) => {
                    item = $(item);
                    total_width += item.outerWidth(true);
                });

                if ((total_width - $(".product__blockaccs").width() - to) < 50)
                    set_next_disabled = true;
            }

            if (set_next_disabled) {
                $(".viewedlist__next.js-product__blockaccsscrollbtn").addClass('slick-disabled');
            } else {
                $(".viewedlist__next.js-product__blockaccsscrollbtn").removeClass('slick-disabled');
            }

            block.animate({scrollLeft: to}, 300);
        });

        jQuery( "body" ).on( "click", ".js-ctabs__more", function(e){
            e.preventDefault();
            let direction = 'right';
            let block = $(".ctabs");

            let to = direction=='left' ? block.scrollLeft() - 824 : block.scrollLeft() + 150;
            // next
            let set_next_disabled = false;

            if (direction=='right') {
                let total_width = 0;

                $(".ctabs__a").map((i, item) => {
                    item = $(item);
                    total_width += item.outerWidth(true);
                });

                if ((total_width - $(".ctabs").width() - to) < 50)
                    set_next_disabled = true;
            }

            if (set_next_disabled) {
                $(".js-ctabs__more").addClass('hidden');
            } else {
                $(".js-ctabs__more").removeClass('hidden');
            }

            block.animate({scrollLeft: to}, 300);
        });

        jQuery( "body" ).on( "click", ".js-accs__tabmore", function(e){
            e.preventDefault();
            let btn = $(this);
            let direction = btn.hasClass('accs__tabmore-prev') ? 'left' : 'right';
            let block = $(".accs__tabs");

            let to = direction=='left' ? block.scrollLeft() - 200 : block.scrollLeft() + 200;

            // prev
            let set_prev_disabled = false;

            if (to <= 0) {
                to = 0;
                set_prev_disabled = true;
            }

            if (set_prev_disabled) {
                $(".accs__tabmore-prev").addClass('hidden');
            } else {
                $(".accs__tabmore-prev").removeClass('hidden');
            }

            // next
            let set_next_disabled = false;

            if (direction=='right') {
                let total_width = 0;

                $(".accs__tab").map((i, item) => {
                    item = $(item);
                    total_width += item.outerWidth(true);
                });

                if ((total_width - block.width() - to) < 50)
                    set_next_disabled = true;
            }

            if (set_next_disabled) {
                $(".js-accs__tabmore:not(.accs__tabmore-prev)").addClass('hidden');
            } else {
                $(".js-accs__tabmore:not(.accs__tabmore-prev)").removeClass('hidden');
            }

            block.animate({scrollLeft: to}, 300);
        });

        jQuery("body").on("click", ".js-product__vmm", function (e) {
            e.preventDefault();
            let btn = $(this);

            $.fancybox.open($(".js-product__vmm"), {
                openEffect: 'none',
                closeEffect: 'none',
                prevEffect: 'none',
                nextEffect: 'none',
                padding: 70,
                helpers: {
                    title: {
                        type: 'inside'
                    },
                    buttons: {}
                },
                index: btn.data('index')
            })
        });

        jQuery("body").on("click", ".js-product__imagemainarr-left, .js-product__imagemainarr-right", function (e) {
            e.preventDefault();
            let btn = $(this);
            let next_index = 0;

            const direction = btn.hasClass('js-product__imagemainarr-left') ? -1 : 1;
            const selected_index = $(".product__imagelist .product__imageitem-active").index();

            if (direction==1) {
                next_index = selected_index + 1;

                if ($(".product__imagelist .product__imageitem").length == next_index) {
                    next_index = 0;
                }
            } else {
                next_index = selected_index - 1;

                if (next_index < 0) {
                    next_index = $(".product__imagelist .product__imageitem").length - 1;
                }
            }

            $(`.product__imagelist .product__imageitem:eq(${next_index})`).trigger('click');
        });

        // питання по outlet товару
        jQuery( "body" ).on( "click", ".js-outlet__question", function(e){
            e.preventDefault();
            e.stopPropagation();
            let btn = $(this);
            let message = btn.data('text');
            let messagetg = btn.data('tgtext');

            $(".order__questiontooltip").remove();
            $("body").prepend('<div class="order__questiontooltip hidden"><div class="order__questiontooltiptext hidden">' + message + '</div><ul>\n' +
                '        <li class="icon-viber"><a href="viber://pa?chatURI=ktc&Text=' + encodeURIComponent(message) + '" class="js-closetooltip" target="_blank">Viber</a></li>\n' +
                '        <li class="icon-telegram2"><a href="tg://resolve?domain=Ktc_ua_bot&start=' + encodeURIComponent(messagetg) + '" class="js-closetooltip" target="_blank">Telegram</a></li>\n' +
                '        <li class="icon-support"><a href="#" class="open-verbox-chat js-closetooltip" target="_blank">Чат</a></li>\n' +
                '    </ul></div>');

            TOOLTIP.open(btn, {
                target: '.order__questiontooltip',
                place: 'bottom',
                subclass: 'support-menu'
            });
        });

        jQuery( "body" ).on( "click", ".js-closetooltip", function(e){
            TOOLTIP.hide();
        });

    });
}

init_GOODS_events();